<template>
    <ProjectManagementDashboard></ProjectManagementDashboard>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const ProjectManagementDashboard = defineAsyncComponent(() =>
    import("../../components/ProjectManagement/Dashboard/Dashboard.vue")
);

export default {
    name: "Project_Management_Dashboard", //The name you are in should not equal the name of the component you are importing.
    components: { ProjectManagementDashboard, AuthLayout },
};
</script>
